import {TestType} from '@esgi/main/libs/core';

export const sectionTitleByTestType: Record<TestType, string> = {
	[TestType.YN]: 'Item Analysis',
	[TestType.Rubric]: 'Rubric Analysis',
	[TestType.Score]: '',
	[TestType.None]: '',
	[TestType.General]: 'General',
};
